import React from 'react';
import { Modal, Box, Typography, Button, Stack, CircularProgress } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

const ConfirmationModal = ({ open, onClose, onConfirm, isLoading }) => {
    return (
        <Modal open={open} onClose={isLoading ? () => {} : onClose} aria-labelledby="modal-title">
            <Box sx={style}>
                <Typography id="modal-title" variant="h6" component="h2">
                    Create as Position
                </Typography>
                <Stack direction="row" spacing={2} sx={{ mt: 3, justifyContent: 'flex-end' }}>
                    <Button onClick={onClose} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} variant="contained" disabled={isLoading}>
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
                    </Button>
                </Stack>
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;
